import { STRIPE_FLOATING_IFRAME_CLEANUP_INTERVAL_MS } from './stripe-floating-iframe-constants';
import { removeStripeFloatingIframes } from './remove-stripe-floating-iframes';

/**
 * Removes Stripe’s floating dev-tools / button iframes app-wide.
 * Runs only after `document.body` exists. Skips iframes inside payment dialogs / Stripe element wrapper
 * so India mandate / 3DS / SetupIntent controllers are not stripped.
 */
const startStripeFloatingIframeCleanup = (): void => {
  if (!document.body) return;
  removeStripeFloatingIframes();
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeName === 'IFRAME') {
          removeStripeFloatingIframes();
        } else if (node.nodeType === 1) {
          const iframes = (node as Element).querySelectorAll?.('iframe');
          if (iframes?.length) removeStripeFloatingIframes();
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setInterval(removeStripeFloatingIframes, STRIPE_FLOATING_IFRAME_CLEANUP_INTERVAL_MS);
};

export const installStripeFloatingIframeCleanup = (): void => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startStripeFloatingIframeCleanup);
  } else {
    startStripeFloatingIframeCleanup();
  }
};
